export const contactData = [
  {
    logo: require("../assets/images/logos/phone.png"),
    alt:'phone',
    type: "Phone",
    detail: "+91 9495322806",
  },
  {
    logo: require("../assets/images/logos/email.png"),
    alt:'email',
    type: "Gmail",
    detail: "jobinjoy235@gmail.com",
  },
  {
    logo: require("../assets/images/logos/linkedin.png"),
    alt:'linkedin',
    type: "Linkedin",
    detail: "jobin0602",
    link: "https://in.linkedin.com/in/jobin0602",
  },
  {
    logo: require("../assets/images/logos/github.png"),
    alt:'github',
    type: "Github",
    detail: "Jobin235",
    link: "https://github.com/Jobin235",
  },
];

export const infoData = [
  {
    placeholder: "First Name",
    name: "first_name",
    type: 'text'
  },
  {
    placeholder: "Last Name",
    name: "last_name",
    type: 'text'
  },
  {
    placeholder: "Email address",
    name: "email",
    type: 'email'
  },
  {
    placeholder: "Company Name",
    name: "company",
    type: 'text'
  },
  {
    placeholder: "Phone Number",
    name: "phone",
    type: 'number'
  },
  {
    placeholder: "Country",
    name: "country",
    type: 'text'
  },
];
export const serviceData = [
  {
    value: "development",
    label: "Website Development",
  },
  {
    value: "migration",
    label: "Website Migration",
  },
  {
    value: "consultation_frontend",
    label: "Frontend Consultation",
  },
  {
    value: "consultation_backend",
    label: "Backend Consultation",
  },
  {
    value: "ecommerce",
    label: "E-commerce Site",
  },
  {
    value: "performance",
    label: "Performance Evaluation",
  },
];

export const budgetData = [
  "Less than $1,000",
  "$1,000 - $5,000",
  "More than $5,000",
];
